import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import alert from './modules/alert'
import history from './modules/history'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    auth,
    alert,
    history,
  }
})





// WEBPACK FOOTER //
// ./src/store/store.js